<!-- Mobile Sidenav Backdrop -->
<div
  [ngClass]="backdropClasses"
  (click)="onBackdropClick($event)"
  [attr.aria-hidden]="!shouldShow"
  role="presentation"></div>

<!-- Mobile Sidenav Container -->
<nav
  [ngClass]="sidenavClasses"
  [attr.aria-hidden]="!shouldShow"
  [attr.aria-label]="'Navigation menu'"
  role="navigation"
  tabindex="-1">
  <!-- Sidenav Header -->
  <div class="mobile-sidenav-header">
    <!-- <div class="logo-section">
            <img src="../../../../assets/images/Hema_NoSlogan_NoBG.png" alt="Logo" class="mobile-logo" />
        </div> -->

    <button
      class="close-button"
      (click)="closeMobileMenu()"
      [attr.aria-label]="'Close navigation menu'"
      type="button">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Sidenav Content -->
  <div class="mobile-sidenav-content">
    <!-- Include the existing side-nav component but in mobile mode -->
    <app-side-nav
      [isCollapsed]="false"
      [isMobileView]="true"
      (menuItemSelected)="onMenuItemSelected()">
    </app-side-nav>
  </div>

  <!-- Optional: Mobile Sidenav Footer -->
  <div class="mobile-sidenav-footer">
    <!-- Add any footer content if needed -->
  </div>
</nav>
